import { first, orderBy } from 'lodash';
import helper from './helper';

export default xScale => (selection) => {
  selection.selectAll('.bar-line').remove();

  const data = first(selection.data());
  const { destinations } = data;
  const destinationsSorted = orderBy(destinations, ['percentage'], ['desc']);
  const domain = xScale.domain();
  const bars = helper.getXDestinationValue(destinationsSorted);

  const barLine = selection.selectAll('.bar-line').data(d => Array(d));
  const gBbar = barLine
    .enter()
    .append('g')
    .classed('bar-line', true);

  const bar = gBbar.selectAll('.bar').data(bars);
  bar
    .enter()
    .append('line')
    .classed('bar', true)
    .attr('x1', (d) => {
      let returnVal = null;
      if (d.start <= domain[1]) {
        returnVal = d.start <= domain[0] ? xScale(domain[0]) : xScale(d.start);
      }

      if (d.start > domain[1]) {
        returnVal = d.start >= domain[1] ? xScale(domain[1]) : xScale(d.start);
      }
      return returnVal;
    })
    .attr('y1', 42)
    .attr('x2', (d) => {
      let returnVal = null;
      if (d.end > domain[0]) {
        returnVal = d.end <= domain[1] ? xScale(d.end) : xScale(domain[1]);
      }

      if (d.end <= domain[0]) {
        returnVal = d.end <= domain[0] ? xScale(domain[0]) : xScale(d.end);
      }
      return returnVal;
    })
    .attr('y2', 42)
    .style('stroke-width', 3)
    .style('stroke', '#28A745');

  return barLine;
};



// WEBPACK FOOTER //
// ./src/components/dashboard_widgets/shipment_completion/barLine.js